module.exports = __webpack_public_path__ + "static/media/Stirrer_Pic5_WhiteBG.387ca0ce.png";